import { ShieldCheck } from "lucide-react";
import PasswordForm from "@/components/PasswordForm";
import { PageHeader, Panel, Empty, useFetch } from "@/components/common";
import { LicenceView } from "@/components/Documents";
import { useAuth } from "@/context/AuthContext";
import { fDate } from "@/lib/api";

const ROLES = { admin: "Administrateur / Direction", direction: "Direction (consultation)", chef_depot: "Chef de dépôt / Logistique", commercial: "Commercial", chauffeur: "Chauffeur / Logistique", administratif: "Administratif" };

function MyLicence() {
  const { data } = useFetch("/documents/me/licence");
  if (!data) return null;
  return (
    <Panel title="Mon permis de conduire (lecture seule)" className="mt-6" testid="profile-licence">
      {data.current ? <LicenceView d={data.current} status={data.status} /> : <Empty text="Aucun permis enregistré — contactez le service administratif" />}
    </Panel>
  );
}

export default function Profile() {
  const { user } = useAuth();
  return (
    <div className="max-w-3xl" data-testid="profile-page">
      <PageHeader overline="Mon compte" title="Profil" />
      <div className="grid md:grid-cols-2 gap-6">
        <Panel title="Informations" testid="profile-info">
          <dl className="space-y-3 text-sm">
            <div><dt className="text-[11px] uppercase font-bold tracking-wider text-slate-500">Nom</dt><dd className="font-semibold text-[#0E2D43]" data-testid="profile-name">{user.name}</dd></div>
            <div><dt className="text-[11px] uppercase font-bold tracking-wider text-slate-500">Email</dt><dd data-testid="profile-email">{user.email}</dd></div>
            <div><dt className="text-[11px] uppercase font-bold tracking-wider text-slate-500">Rôle</dt><dd>{ROLES[user.real_role || user.role]}{user.job_title ? ` — ${user.job_title}` : ""}</dd></div>
            <div><dt className="text-[11px] uppercase font-bold tracking-wider text-slate-500">Dernier changement de mot de passe</dt><dd>{fDate(user.password_changed_at)}</dd></div>
          </dl>
          <div className="mt-5 flex items-start gap-2 text-xs text-slate-500"><ShieldCheck className="w-4 h-4 text-emerald-600 shrink-0" /> Votre mot de passe est chiffré : personne, y compris l'administrateur, ne peut le consulter.</div>
        </Panel>
        <Panel title="Modifier mon mot de passe" testid="profile-password">
          <PasswordForm />
        </Panel>
      </div>
      {["commercial", "chauffeur"].includes(user.role) && <MyLicence />}
    </div>
  );
}
